module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/image-cells/image-cells.component.css
// module id = ./src/app/examples/image-cells/image-cells.component.css
// module chunks = main